import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import Loading from "@images/loading.gif";
import Image from "next/image";
import { ReactNode } from "react";

export interface DialogProps {
  loading?: boolean;
  icon?: string | any;
  title?: string;
  children?: ReactNode;
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  actions?: {
    text: string;
    onClick: () => void;
    primary?: boolean;
  }[];
  size?: string;
}

const Dialog = ({
  loading,
  icon,
  title,
  children,
  isOpen,
  onOpen,
  onClose,
  actions,
  size,
}: DialogProps) => {
  const [isMobile] = useMediaQuery("(max-width: 640px)");
  size = isMobile ? "full" : size || "md";
  isOpen = isOpen ?? true;
  onClose = onClose ?? (() => {});

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered size={size}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <div className="flex flex-col content-center items-center">
            {loading ? (
              <div className="w-8 mb-4">
                <Image src={Loading} layout="responsive" alt="" />
              </div>
            ) : icon ? (
              <div className="w-8 mb-4">
                <Image src={icon} layout="responsive" alt="" />
              </div>
            ) : (
              ""
            )}
            <p className="w-5/6 text-center">{title}</p>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <>
              <h1 className="flex flex-row justify-center">Loading...</h1>
              {/* <p className="text-center">{children}</p> */}
            </>
          ) : (
            children
          )}
        </ModalBody>
        <ModalFooter>
          {!loading && actions && actions.length > 0 ? (
            <ButtonGroup variant="ghost" className="self-end" spacing="4">
              {actions.map((action, i) => {
                return (
                  <Button
                    color={action.primary ? "primary.300" : "neutral.200"}
                    onClick={action.onClick}
                    key={i}
                    fontSize="0.9em"
                  >
                    {action.text}
                  </Button>
                );
              })}
            </ButtonGroup>
          ) : (
            <></>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default Dialog;
